import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'Common/ReactTableWrapper';
import { Checkbox, Form } from 'semantic-ui-react';

import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

export class SelectServedItemsTable extends Component {
  static propTypes = {
    servedItems: PropTypes.array.isRequired,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
  };

  columns = [
    {
      Header: 'Item Id',
      accessor: 'Id',
      filterable: true,
      maxWidth: 70,
    },
    {
      Header: 'Item Description',
      accessor: 'Description',
      filterable: true,
      minWidth: 300,
    },
    {
      Header: 'Short Description',
      accessor: 'ShortDescription',
      filterable: true,
      minWidth: 150,
    },
    {
      Header: 'Nutrition Code',
      accessor: 'NutritionCode',
      filterable: true,
    },
    {
      Header: 'Alternate Item',
      accessor: 'AlternateId',
      filterable: true,
    },
    {
      Header: 'Item Category',
      accessor: 'POS_ItemCategory.Description',
      filterable: true,
    },
    {
      filterable: false,
      sortable: false,
      Cell: ({ original }) => {
        const { onChange, value } = this.props.input;
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={value.some(v => v === original.Id)}
              onChange={(e, data) => {
                let selected = [...value].filter(id => id !== original.Id);

                if (data.checked) {
                  selected.push(original.Id);
                }

                onChange(selected);
              }}
            />
          </div>
        );
      },
      Header: () => {
        const { servedItems } = this.props;
        const { onChange, value } = this.props.input;
        return (
          <div style={{ textAlign: 'center' }}>
            <div>Selected</div>
            <Checkbox
              checked={value.length === servedItems.length}
              indeterminate={
                value.length > 0 && value.length !== servedItems.length
              }
              onChange={(e, data) => {
                onChange(
                  data.checked
                    ? servedItems.reduce((carry, item) => {
                        return [...carry, item.Id];
                      }, [])
                    : []
                );
              }}
            />
          </div>
        );
      },
    },
  ];

  render() {
    const {
      meta: { dirty, error },
    } = this.props;
    return (
      <Form.Field error={dirty && error ? true : false}>
        <ReactTable
          saveState={{
            tableName: TableNamesEnum.SERVED_ITEM_ACCESS_SETUP_TABLE,
          }}
          loading={this.props.loading}
          data={this.props.servedItems}
          columns={this.columns}
        />
        {dirty && error ? <span>{error}</span> : null}
      </Form.Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/serveditemaccesssetup/components/SelectServedItemsTable.js